import { render, staticRenderFns } from "./PCQuestionnaire.vue?vue&type=template&id=997dbe9c&"
import script from "./PCQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./PCQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports